import Api from "@services/api";

const PAGE_SIZE = 12;

export const getCategoryPageAttr = async (slug: string) => {
  const resp = await Api().get(`/category-pages/${slug}?populate=deep`);
  return resp.data;
};

export const getProductsByCategory = async (page: number, slug: string) => {
  const res = await Api().get(
    `/categories?populate=deep&filters[slug][$eq]=${slug}&sort=createdAt&pagination[page]=${page}&pagination[pageSize]=${PAGE_SIZE}`
  );

  return res.data;
};

export const getProductsBelongCategory = async (
  page: number,
  slug: string,
  sort: string
) => {
  const res = await Api().get(
    `/category-product?category=${slug}&page=${page}&pageSize=${PAGE_SIZE}&sort=${sort}`
  );

  return res.data;
};
